// (C) Copyright 2020 CNCC Services <https://www.cncc.fr/>
// This program is the sole property of CNCC Services and is not free software.

import { createEffect } from "effector";
import { NboBranchList } from "../../api/backend-openapi";
import "whatwg-fetch";
import configuration from "../../utils/Config";
import { restGetUniqueHandler } from "../../utils/rest/RestClient";

const baseUrl = configuration.backendBaseUrl;
const newsUrl = baseUrl + "/reference/branches";

export const requestGetBranches = createEffect({
  handler: restGetUniqueHandler<NboBranchList>(newsUrl)
});
